/**
 * A function to create a log object for the 'portfolioPageViewed' event (evid: 2)
 *
 * Event description: Every time a project/collection/portfolio page is viewed in different view modes (editor/preview/viewer)
 *
 * @param {portfolioPageViewedParams} params - The parameters for this event
 * @property {string} viewMode - editor/preview/viewer
 * @property {string} portfolioViewMode - editor/preview/viewer of portfolio
 * @property {string} pageName - project/collection/portfolio
 * @return {LogObject<portfolioPageViewedParams>} LogObject<portfolioPageViewedParams>
 */
export function portfolioPageViewed(params) {
    return { evid: 2, src: 150, endpoint: 'portfolio-users-of-users', params: params };
}
//# sourceMappingURL=index.js.map